import { render, staticRenderFns } from "./NoticeViewModal.vue?vue&type=template&id=97aa9b6a&"
import script from "./NoticeViewModal.vue?vue&type=script&lang=js&"
export * from "./NoticeViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports